import React from 'react';
import { Link } from 'react-router-dom';
import MainNav from '../main-nav';
import logo from './logo_animated.gif';

import './style.css';

const Header = () => (
  <header className="aq-header">

          <Link to="/" className="logo">
            <img src={logo} alt="Logo Airqast" width="152px" height="43px" />
          </Link>

          <MainNav />

  </header>
);

export default Header;



// WEBPACK FOOTER //
// ./src/app/header/index.js